import PropTypes from "prop-types";
import * as React from "react";
import {
  BlockIcon,
  CheckCircleIcon,
  ErrorCircleIcon,
  Typography,
} from "../../themeV2";
import css from "./ShopInfo.module.css";

// Status is carried by icon shape, colour and the visually hidden word alike,
// so it survives both colour blindness and a screen reader.
const STATUS = {
  pass: {
    Icon: CheckCircleIcon,
    className: css.checkIconPass,
    word: "Passing",
  },
  fail: {
    Icon: ErrorCircleIcon,
    className: css.checkIconFail,
    word: "Failing",
  },
  not_applicable: {
    Icon: BlockIcon,
    className: css.checkIconSkipped,
    word: "Not applicable",
  },
};

const detailLine = ({ productName, shopName }) =>
  `${productName} — split with ${shopName}`;

export default function SetupChecks({ checks }) {
  return (
    <ul className={css.checkList}>
      {checks.map(({ id, label, status, message, detail }) => {
        const { Icon, className, word } =
          STATUS[status] ?? STATUS.not_applicable;

        return (
          <li className={css.checkItem} key={id}>
            <span className={[css.checkIcon, className].join(" ")}>
              <Icon aria-hidden="true" />
            </span>
            <span>
              <Typography
                variant="label-lg"
                as="span"
                className={css.checkLabel}
              >
                {label}
                <span className={css.visuallyHidden}>{` — ${word}`}</span>
              </Typography>
              {status === "fail" ? (
                <Typography variant="label-md" as="p" color="variant">
                  {message}
                </Typography>
              ) : null}
              {status === "fail" && detail?.length
                ? detail.map((row) => (
                    <Typography
                      variant="label-md"
                      as="p"
                      color="variant"
                      key={detailLine(row)}
                    >
                      {detailLine(row)}
                    </Typography>
                  ))
                : null}
            </span>
          </li>
        );
      })}
    </ul>
  );
}

SetupChecks.propTypes = {
  checks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      status: PropTypes.oneOf(Object.keys(STATUS)).isRequired,
      message: PropTypes.string,
      detail: PropTypes.array,
    }),
  ).isRequired,
};
